import AuthService from './auth-service';

export const auth = {
  namespaced: true,
  state: {
    status: {},
    user: null,
  },
  actions: {
    login({ commit }, loginInfo) {
      return AuthService.login(loginInfo).then(
        (user) => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        (error) => {
          commit('loginFailure');
          return Promise.reject(error.response.data);
        }
      );
    },
    loginCustomer({ commit }, loginInfo) {
      return AuthService.loginCustomer(loginInfo).then(
        (user) => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        (error) => {
          commit('loginFailure');
          return Promise.reject(error.response.data);
        }
      );
    },
    logout({ commit }) {
      const refreshToken = auth.state.user
          ? auth.state.user.refreshToken
          : null;
      AuthService.logout(refreshToken);
      commit('logout');
    },

    switchCenter({ commit }, centerId) {
      return AuthService.switchCenter(centerId).then(
          (user) => {
            commit('loginSuccess', user);
            return Promise.resolve(user);
          },
          (error) => {
            return Promise.reject(error.response.data);
          }
      );
    },
  },
  getters: {
    isSystemAdmin(state) {
      // 시스템 관리자 여부
      return state.user.tt === 'F';
    },
    isInsteadOfAdmin(state) {
      // 시스템 관리자 여부
      return state.user.insteadAdmin;
    },
    isCareAdmin(state) {
      // 케어 어드민 여부
      return state.user.tt === 'S';
    },
    isCenterAdmin(state) {
      // 센터 어드민 여부
      return state.user.tt === 'C';
    },
    isCenterStaff(state) {
      // 센터 직원 여부
      return state.user.tt === 'D';
    },
    isCustomer(state) {
      // 일반 회원 여부
      return state.user.tt === 'N';
    },
    cId(state) {
      // 로그인한 센터 id
      return state.user ? state.user.cid : null;
    },
    staffId(state) {
      // 로그인한 staff id
      return state.user.uid;
    },
    storeTest(state) {
      return state.user;
    },
    staffEmail(state) {
      return state.user.userId;
    },
    roleName(state) {
      // 권한 이름
      return state.user.rnm;
    },
    userName(state) {
      return state.user.unm;
    },
    centerChains(state) {
      // 체인점 목록 (체인점 최고관리자가 아니면 length == 0)
      return state.user.centerChains;
    },
  },
  mutations: {
    loginSuccess(state, user) {
      state.status = { loggedIn: true };
      state.user = user;
    },
    loginFailure(state) {
      state.status = {};
      state.user = null;
    },
    logout(state) {
      state.status = {};
      state.user = null;
      state.centers = [];
    },
    setCenters(state, centers) {
      state.centers = centers;
    }
  },
};
